import i18n from 'i18n-literally'

import createEntityBundle from '~/src/Lib/createEntityBundle'
import { parseApiErrors } from '~/src/Lib/Utils'
import { Kpi as schema } from '~/src/Store/Schemas'

const ACTION_TO_SUCCESS = {
  get delete() {
    return i18n`deleted`
  },
  get save() {
    return i18n`saved`
  },
}
const ACTION_TO_FAILURE = {
  get delete() {
    return i18n`delete`
  },
  get save() {
    return i18n`save`
  },
}

const bundle = createEntityBundle({
  name: 'kpis',
  apiConfig: {
    schema,
    snackbar: ({ status, dispatch, error, action }) => {
      dispatch({
        actionCreator: 'doAddSnackbarMessage',
        args: [
          status === 'succeed'
            ? i18n`Successfully ${ACTION_TO_SUCCESS[action]} KPI`
            : i18n`Unable to ${ACTION_TO_FAILURE[action]} KPI: ${parseApiErrors(error)}`,
        ],
      })
    },
  },
})

export default {
  ...bundle,
}
